export default "__VITE_ASSET__0LaIPfvl__"